export class PAReviewRejectionReasonModel {
    constructor() {
        this.rejectedReason = "";
    }
}
export default class PAReviewRejectionReason extends PAReviewRejectionReasonModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
